<template>
    <div class="inventory-summaries row">
        <div class="col-lg-3">
            <div class="box box--primary" style="min-height:120px;">
                <div class="m-2">
                    <h4
                        class="text-accent font-weight-bold mb-0"
                        :class="{ 'is-loading': isFetching }">
                        <span>{{stock}}</span>
                    </h4>
                    <span class="d-block mt-2"><i class="bi bi-box"></i> {{ $t('Total Stock Return Order') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import productsApi from '@/api/products';

export default {
	name: 'Overviews',
	props: {
		productId: {
			type: Object,
			default: null,
		},
	},
	data: () => ({
		isFetching: false,
		stock: 0,
	}),
	methods: {
		fetchProductStockRTS() {
			if (!this.productId) {
				return;
			}
			const productId = this.productId.$oid;
			this.isFetching = true;
			const params = {
				type: 'stock',
			};
			const callback = (response) => {
				const data = response.data;
				this.stock = data.stock;
				this.isFetching = false;
			};
			const errorCallback = () => {
				this.isFetching = false;
			};
			productsApi.getActivityProductStockRTS(productId, params, callback, errorCallback);
		},
	},
	created() {
		this.fetchProductStockRTS();
	},
	watch: {
		productId() {
			this.fetchProductStockRTS();
		},
	},
};
</script>
